import { useContext } from 'react';
import { useRouter } from 'next/router';
import { User } from '../../../constants/icons';
import { Box, Button, ButtonProps } from '@chakra-ui/react';
import { IconUserFilled } from '@tabler/icons-react';
import SessionContext from 'session/SessionContext';
import { colors } from 'constants/constants';

export default function MyPages(props: ButtonProps): JSX.Element {
  const session = useContext(SessionContext);
  const router = useRouter();

  const handleClick = () => {
    router.replace(session.user ? '/mypages' : '/login');
  };

  return (
    <Button
      height="2.5em"
      fontSize="15px"
      pl="0.8em"
      pr="0.3em"
      rightIcon={(
        <Box
          bg="white"
          borderRadius="full"
          width="32px"
          height="32px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          color={colors.primary[900]}>
          <IconUserFilled size={24} />
        </Box>
      )}
      onClick={handleClick}
      backgroundColor={colors.primary[900]}
      _hover={
        { backgroundColor: colors.secondary[900] }
      }
      {...props}>
      Mina sidor
    </Button>
  );
}
